import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=67725be5&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=ts"
export * from "./Infos.vue?vue&type=script&lang=ts"
import style0 from "./Infos.vue?vue&type=style&index=0&id=67725be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67725be5",
  null
  
)

export default component.exports